module.exports = __webpack_public_path__ + "homeStatic/img/yuedu.a67bc1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personal/yuedu.png
// module id = fqP/
// module chunks = 1